import * as React from 'react'
import { css, cx } from '@emotion/css'
import {
  ApplicationArchitectureCard,
  containerWidth,
  negativeMargin
} from '../../application-architecture-card'
import { browserBarWidth } from '../../browser-bar'
import { WrappedBrowserBar } from '../../wrapped-browser-bar'
import { FlowMapColumnTitle } from '../../column-title'
import { LegacyGridSpinner } from '../../../../legacy-design-system/legacy-grid'
import { ApplicationArchitecture } from '../../application-architecture-loader'
import { Role } from '@contrast-security-inc/base-types'
import { AgentFeature } from '../../../agent-features'
import { architectureColumnWidth, getColumnContainerStyle } from '../../index'

export interface Props {
  readonly appID: string
  readonly organizationID: string
  readonly isLoading: boolean
  readonly appArchitecture: ApplicationArchitecture | undefined
  readonly organizationRole: Role
  readonly features: AgentFeature[]
  readonly isFreemiumOrganization: boolean
}

export class ApplicationArchitectureColumn extends React.Component<Props> {
  public render() {
    const {
      isLoading,
      isFreemiumOrganization,
      features,
      organizationRole,
      organizationID,
      appArchitecture,
      appID
    } = this.props

    return (
      <div
        className={cx(
          getColumnContainerStyle(architectureColumnWidth),
          css`
            cursor: default;
            margin-bottom: 20px;
          `
        )}
      >
        {!isLoading ? (
          !!appArchitecture ? (
            <div
              className={css`
                display: flex;
                flex-direction: row;
                min-width: ${browserBarWidth +
                architectureColumnWidth -
                negativeMargin}px;
                justify-content: flex-end;
              `}
            >
              <WrappedBrowserBar
                organizationID={organizationID}
                applicationID={appID}
              />

              <div
                className={css`
                  position: relative;
                  z-index: 1;
                  left: -${negativeMargin}px;
                `}
              >
                <ApplicationArchitectureCard
                  organizationID={organizationID}
                  applicationID={appID}
                  features={features}
                  online={appArchitecture.online}
                  assess={appArchitecture.hasAssess}
                  hasAProtectedServer={appArchitecture.hasAProtectedServer}
                  isFreemiumOrganization={isFreemiumOrganization}
                  language={appArchitecture.language}
                  attackStatus={appArchitecture.attackStatus}
                  violatedCompliancePolicies={
                    appArchitecture.violatedCompliancePolicies
                  }
                  organizationRole={organizationRole}
                  vulnerabilityBreakdown={
                    appArchitecture.vulnerabilityBreakdown
                  }
                  serverEnvironments={appArchitecture.serverEnvironments}
                  technologiesBreakdown={appArchitecture.technologiesBreakdown}
                />
              </div>
            </div>
          ) : undefined
        ) : (
          <div
            className={css`
              width: ${containerWidth}px;
              padding: 10px 15px 15px 20px;
            `}
          >
            <FlowMapColumnTitle
              titleI18n={'title_applicationArchitecture_appArchitecture'}
              position="flex-start"
            />
            <LegacyGridSpinner data-testid="app-architecture-loading-indicator" />
          </div>
        )}
      </div>
    )
  }
}
